module.exports = __webpack_public_path__ + "img/tag-top-2x.41d8372.png";